import axios from "../axiosClientDMS";

export const getDMSDevices = async (
  PageNumber: any,
  PageSize: any,
  tcCode: any,
  siteCode: any,
  blockCode: any,
  isActive: any,
  isOnline: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/DeviceListBySearch`, {
    params: {
      PageNumber,
      PageSize,
      tcCode,
      siteCode,
      blockCode,
      isActive,
      isOnline,
      SortBy,
      SortDirection,
      searchText,
    },
    signal,
  });

  return res?.data;
};

export const getActivityListByDeviceId = async (
  PageNumber: any,
  pageSize: any,
  deviceId: any,
  SortBy: any,
  SortDirection: any,
  StartDate: any,
  EndDate: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/GetAcivityListByDeviceId`, {
    params: {
      PageNumber,
      pageSize,
      deviceId,
      SortBy,
      SortDirection,
      StartDate,
      EndDate,
      searchText,
    },
    signal,
  });

  return res?.data;
};

export const getAlertListByDeviceId = async (
  PageNumber: any,
  pageSize: any,
  deviceId: any,
  SortBy: any,
  SortDirection: any,
  StartDate: any,
  EndDate: any,
  SearchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/GetAlertListByDeviceId`, {
    params: {
      PageNumber,
      pageSize,
      deviceId,
      SortBy,
      SortDirection,
      StartDate,
      EndDate,
      SearchText,
    },
    signal,
  });

  // let data = await res?.data;

  // const modifiedData = data?.data.map((data: any, index: number) => {
  //   return {
  //     id: index + 1,
  //     serial: data?.serial,
  //     activityType: data?.payload,
  //     timeStamp: data?.slot_data,
  //     details: `No ${data?.payload} received since ${moment
  //       .utc(data?.lastresponseacknowledged)
  //       .local()
  //       .format("D-MMM-Y HH:mm:ss")}`,
  //   };
  // });

  // data.data = modifiedData;

  // return data;
  return res?.data;
};

export const getMessageExchangedList = async (
  PageNumber: any,
  pageSize: any,
  deviceId: any,
  SortBy: any,
  SortDirection: any,
  StartDate: any,
  EndDate: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmsapp/Device/MessageExchangeListByDeviceId`, {
    params: {
      PageNumber,
      pageSize,
      deviceId,
      SortBy,
      SortDirection,
      StartDate,
      EndDate,
      searchText,
    },
    signal,
  });

  let data = await res?.data;

  const modifiedData = data?.data.map((data: any, index: number) => {
    return {
      id: index + 1,
      serial: data?.serial,
      alertType: data?.alertType,
      timeStamp: data?.timeStamp,
      details: data?.details,
    };
  });

  data.data = modifiedData;

  return data;
};
